import api from '@/api';
import Cookies from '@/portal-cookie';
import base64toPDF from '../../lib/base64ToPDF';

let types = {
    SET_STATE: 'SET_STATE',
    RESET_FORM_ADDRESS: 'RESET_FORM_ADDRESS',
    RESET_FORM_CONTACT: 'RESET_FORM_CONTACT',
};



const 
initialState = 
{
    shippingAddresses: [],
    billingAddresses: [],
    selectedAddress: [],
    contacts: [],
    selectedContact: [],
    loading: false,
    loadedVendorCode: '',
    cardCode: '',
    cardType: '',
    // update form
    addressSending: false,
    addressLoading: false,
    addressFormVisible: false,
    countries: [],
    statesByCountry: {},
    states: {},
    addressForm: {
        row_index: 0,
        type: '',
        address_line_1: '',
        address_line_2: '',
        address_city: '',
        address_state: '',
        address_zip: '',
        address_name: '',
        address_attn: '',
        address_country: '',
    },

    // update form contacts
    contactSending: false,
    contactLoading: false,
    contactFormVisible: false,
    contactForm: {
        row_index: 0,
        Name: '',
        FirstName: '',
        LastName: '',
        Tel1: '',
        E_MailL: '',
    },

    // update form contacts
    otherSending: false,
    otherLoading: false,
    otherFormVisible: false,

    sendModal: false,
    sendResponse: '',
    sendModalTitle: '',
};


export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
        {
            return {...state, ...action.data };
        }
        case types.RESET_FORM_ADDRESS:
            return {
                ...state,
                addressForm: {
                    ...addressForm,
                },
            };
        case types.RESET_FORM_CONTACT:
            return {
                ...state,
                contactForm: {
                    ...contactForm,
                },
            };
        case types.RESET_FORM_OTHER:
            return {
                ...state,
                otherForm: {
                    ...otherForm,
                },
            };
        default:
            return state;
};
}
export default reducers;



export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),
    resetFormAddress: () => ({ type: types.RESET_FORM_ADDRESS }),
    resetFormContact: () => ({ type: types.RESET_FORM_CONTACT }),
    loadVendorCode: () => async (dispatch) => {
        try {
            const userKey  = Cookies.get('TS_UserKey', '');
            const response = await api.get('/invoices/vendor-code', {
                params: {
                    userKey: userKey,
                },
            });
            dispatch({
                type: types.SET_STATE,
                data: {
                    loading: false,
                    loadedVendorCode: true,
                    cardCode: response.BPCode,
                    cardType: response.BPType,
                },
            });
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.SET_STATE,
                data: {
                    loading: false,
                    loadedVendorCode: true,
                    cardCode: '',
                    cardType: '',
                },
            });
        }
    },

    loadAddresses: () => async (dispatch, getState) => {
        let state    = getState().dashboard,
            cardCode = state.cardCode;

        dispatch(actions.setState({ loading: true }));

        try {
            let shippingAddress = await api.get(`/dashboard/address`, { params: {cardCode: cardCode, type: 'S' }});
            let billingAddress  = await api.get(`/dashboard/address`, { params: {cardCode: cardCode, type: 'B' }});
            let locations       = await api.get('/dashboard/locations');

            dispatch({
                type: types.SET_STATE,
                data: {
                    loading:   false,
                    shippingAddresses: shippingAddress,
                    billingAddresses: billingAddress,
                    countries: locations.countries,
                    states: locations.states
                },
            });
        } catch(err) {
            dispatch({
                type: types.SET_STATE,
                data: {
                    loading: false,
                },
            });
        }

    },

    requestAddressChange: (values) => async (dispatch, getState) => {
        let state    = getState().dashboard,
            cardCode = state.cardCode;
        dispatch(actions.setState({addressSending: true}))
        try {
            let sendRequest = await api.post(`/dashboard/request-address-change`, { address: values, cardCode: cardCode});

            dispatch(actions.setState({
                sendModal: true,
                sendModalTitle: 'Update Request Sent',
                sendResponse: sendRequest.resMessage,
            }))
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.SET_STATE,
                data: {
                    sendModal: true,
                    sendModalTitle: 'Update Request Failed',
                    sendResponse: 'Failed to send address request email to staff, please reach out to Brewery Branding or try again later.',
                },
            });
        }
        dispatch(actions.setState({addressSending: false}))
    },

    loadContacts: () => async (dispatch, getState) => {
        let state    = getState().dashboard,
            cardCode = state.cardCode;

        dispatch(actions.setState({ loading: true }));

        try {
            let contacts = await api.get(`/dashboard/contacts`, { params: {cardCode: cardCode}});
            
            dispatch({
                type: types.SET_STATE,
                data: {
                    loading:   false,
                    contacts: contacts,
                },
            });
        } catch(err) {
            dispatch({
                type: types.SET_STATE,
                data: {
                    loading: false,
                },
            });
        }

    },

    requestContactChange: (values) => async (dispatch, getState) => {
        let state    = getState().dashboard,
            cardCode = state.cardCode;
        dispatch(actions.setState({contactSending: true}))
        try {
            let sendRequest = await api.post(`/dashboard/request-contact-change`, { contact: values, cardCode: cardCode});

            dispatch(actions.setState({
                sendModal: true,
                sendModalTitle: 'Update Request Sent',
                sendResponse: sendRequest.resMessage,
            }))
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.SET_STATE,
                data: {
                    sendModal: true,
                    sendModalTitle: 'Update Request Failed',
                    sendResponse: 'Failed to send contact request email to staff, please reach out to Brewery Branding or try again later.',
                },
            });
        }
        dispatch(actions.setState({contactSending: false}))
    },

    requestOtherChange: (values) => async (dispatch, getState) => {
        let state    = getState().dashboard,
            cardCode = state.cardCode;
        dispatch(actions.setState({otherSending: true}))
        try {
            let sendRequest = await api.post(`/dashboard/request-other-change`, { other: values, cardCode: cardCode});

            dispatch(actions.setState({
                sendModal: true,
                sendModalTitle: 'Update Request Sent',
                sendResponse: sendRequest.resMessage,
            }))
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.SET_STATE,
                data: {
                    sendModal: true,
                    sendModalTitle: 'Update Request Failed',
                    sendResponse: 'Failed to send other request email to staff, please reach out to Brewery Branding or try again later.',
                },
            });
        }
        dispatch(actions.setState({otherSending: false}))
    },

    load_statement_document: () => async(dispatch, getState) => {
        let state    = getState().dashboard,
            cardCode = state.cardCode;

        dispatch(actions.setState({loading: true}))
		const response = await api.get('/dashboard/statement-pdf', {
			params: {
				cardCode: cardCode,
			},
		});

		let fileData = response.document.FileData;
		fileData = base64toPDF(fileData);

		const fileURL = await URL.createObjectURL(fileData);

		if (fileData) {
			window.open(fileURL);
		} else {
			message.error(`Could not load statement report for bp ${cardCode}`);
		}

        dispatch(actions.setState({loading: false}))
	},

};
